import { createGlobalStyle } from "styled-components";

import AkkuratLLLightWoff from "../fonts/AkkuratLL-Light.woff";
import AkkuratLLLightWoff2 from "../fonts/AkkuratLL-Light.woff2";

export const GlobalStyles = createGlobalStyle`
@font-face {
  font-family: 'Akkurat LL';
  src: url('${AkkuratLLLightWoff2}') format('woff2'),
       url('${AkkuratLLLightWoff}')) format('woff'),
}

* {
  box-sizing: border-box;
}
`;
